module.exports = __webpack_public_path__ + "img/39.2bd82395.jpg";